export default __webpack_public_path__ + "static/media/touch_range.e211fa6b.svg";